export const PROTOCOL_AI_MODEL = 'Qwen 2.5';
export const PROTOCOL_AI_FOOTER = `Сгенерировано ИИ, модель — ${PROTOCOL_AI_MODEL}`;
export const PROTOCOL_AI_DISCLAIMER =
  'ИИ-модель находится в процессе обучения и может ошибаться.';

/** Убирает устаревшие упоминания моделей из экспорта; оставляет единый футер. */
export function sanitizeExportModelBranding(text: string): string {
  if (!text?.trim()) return text || '';
  let result = text;
  const replacements: Array<[RegExp, string]> = [
    [/Сгенерировано ИИ, модель\s*[-—:]\s*(?:Google\s+)?Gemini[^\n]*/gi, PROTOCOL_AI_FOOTER],
    [/Сгенерировано ИИ, модель\s*[-—:]\s*Qwen[^\n]*/gi, PROTOCOL_AI_FOOTER],
    [/^Модель\s*[-—:]\s*Gemini[^\n]*$/gim, `Модель — ${PROTOCOL_AI_MODEL}`],
    [/^Модель\s*[-—:]\s*Qwen[^\n]*$/gim, `Модель — ${PROTOCOL_AI_MODEL}`],
    [/Google\s+Gemini\s*2\.5\s*Flash/gi, PROTOCOL_AI_MODEL],
    [/Google\s+Gemini\s*2\.5\s*Pro/gi, PROTOCOL_AI_MODEL],
    [/Google\s+Gemini[^\n,.;]*/gi, PROTOCOL_AI_MODEL],
    [/Gemini\s*2\.5\s*Flash/gi, PROTOCOL_AI_MODEL],
    [/Gemini\s*2\.5\s*Pro/gi, PROTOCOL_AI_MODEL],
    [/gemini-2\.5-flash/gi, PROTOCOL_AI_MODEL],
    [/gemini-2\.5-pro/gi, PROTOCOL_AI_MODEL],
    [/Qwen\s*2\.5\s*Instruct/gi, PROTOCOL_AI_MODEL],
  ];
  for (const [pattern, value] of replacements) {
    result = result.replace(pattern, value);
  }
  return result;
}

export function protocolAiFooterHtml(): string {
  return `<p class="ai-footer" style="margin-top:24pt;padding-top:12pt;border-top:1px solid #ddd;text-align:center;"><span style="display:inline-block;padding:8pt 14pt;border-radius:6pt;background:#f1f5f9;border:1px solid #e2e8f0;text-align:center;max-width:460px;"><span style="display:block;font-size:10.5pt;font-weight:700;color:#334155;font-style:normal;line-height:1.4;">${PROTOCOL_AI_FOOTER}</span><span style="display:block;margin-top:4pt;font-size:9.5pt;font-weight:700;color:#475569;font-style:normal;line-height:1.45;">${PROTOCOL_AI_DISCLAIMER}</span></span></p>`;
}
